<template>
<body class="white-bg">
    <div class="research">
       <div id="complete" class="ibox page-full">
          <div class="r-header">
             {{headerText}}
          </div>
          <div class="r-box page-middle no-borders">
             <div class="text-center mb-4 r-notice" style="padding: 10px 0px;">
                <div style="font-size: 20px;">
                   <span v-html="completeText"></span>
                </div>
             </div>
          </div>
       </div>
    </div>
 </body>
</template>

<script>
import Service from '@/services/NominateService'

export default {
  name: 'home',
  data() {
    return {
       hash: null,
       headerText: null,
        completeText: null,
    }
  },
  mounted() {
      this.hash = this.$route.params.hash
      window.scrollTo(0, 0)

      Service.getMyInfo(this.hash,
         (data_ok) => {
            if (data_ok.code != 200) {
               alert(data_ok.message)
               return
            }

            let registerHash = data_ok.data.registerHash
            this.headerText = data_ok.data.topicTitle
            this.completeText = "입후보 정보 입력이<br/>완료 되었습니다.<br/><br/>" 
               
               + "<font size='2'>[입후보자 추천링크]<br/><a href='https://www.sktunion.com/nominee/election/recommend/" + registerHash + "'>https://www.sktunion.com/nominee/election/recommend/" + registerHash + "</a></font><br/><br/>"
               + "위 추천링크를 선거인들에게 전달하시어 후보 추천을 받으시기 바랍니다.<br/>"
               + "<font size='4'>* 선거구 및 선거인 명부는 조합홈페이지 선거공고 공지를 통해 확인하실 수 있습니다.</font><br/><br/>"

                + "<font size='2'>위 [입후보자 추천링크]를 입후보자 본인이 접속하는 경우, 현황 확인 및 최종 제출할 수 있습니다.<br/>"
                + "동일 선거구의 선거인 1/10의 추천을 받으신 후, 꼭 최종 제출을 하시기 바랍니다.<br/><br/>"
                + "* 최종 제출 되어야 입후보자 등록이 완료됩니다.<br/>"
               
               + "안내문자와 추천링크는 SMS로 한번 더 발송 드립니다.<br/><br/>"
               + "감사합니다."
               }
      )
  },
  methods: {
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
